import type { SVGProps } from "react";

/** Existing bulb geometry with independently themed surface and foreground. */
export default function LearnMoreBulb(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 50 50"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <rect width="49.151" height="48.825" rx="10" fill="var(--primary-tint)" />

      <g transform="translate(14.514,10.21)">
        <path
          d="M120.263,115.478a5.37,5.37,0,0,1,1.559,4.516.43.43,0,0,0,.108.351.445.445,0,0,0,.344.144h3.467a.459.459,0,0,0,.2.052.452.452,0,0,0,.2-.044l3.487-.013a.455.455,0,0,0,.451-.518,5.129,5.129,0,0,1,1.59-4.458l0,0a7.372,7.372,0,0,0,2.164-5.164,7.291,7.291,0,0,0-2.215-5.218,8.033,8.033,0,0,0-11.153-.065,7.181,7.181,0,0,0-.207,10.422Zm-1.223-5.25a6.37,6.37,0,0,1,2.06-4.51,7.085,7.085,0,0,1,4.779-1.966h.109a7.05,7.05,0,0,1,4.993,2.02,6.384,6.384,0,0,1,1.942,4.567,6.463,6.463,0,0,1-1.9,4.523,6.122,6.122,0,0,0-1.9,4.711l-2.728.011V111.4c.054.067.113.148.182.247a1.446,1.446,0,0,0,2.662,0c.243-.348.364-.49.582-.49a.457.457,0,1,0,0-.913,1.606,1.606,0,0,0-1.331.88c-.243.348-.364.49-.582.49s-.339-.142-.582-.49a1.446,1.446,0,0,0-2.661,0c-.243.348-.363.49-.582.49s-.339-.142-.582-.49a1.607,1.607,0,0,0-1.331-.88.457.457,0,1,0,0,.913c.218,0,.339.142.582.49a1.446,1.446,0,0,0,2.662,0l.068-.1v8.04l-2.706.011a6.318,6.318,0,0,0-1.87-4.769A6.352,6.352,0,0,1,119.04,110.228Z"
          transform="translate(-115.936 -97.395)"
          fill="var(--primary-base)"
        />
        <path
          d="M89.673,11.326a.457.457,0,0,0,.457-.457V7.957a.457.457,0,0,0-.913,0v2.913A.457.457,0,0,0,89.673,11.326ZM97.2,14.732a.455.455,0,0,0,.3-.117l2.252-2.021a.457.457,0,0,0-.61-.68l-2.252,2.021a.457.457,0,0,0,.305.8Zm-15.115-.4a.457.457,0,1,0,.634-.658L80.557,11.6a.457.457,0,1,0-.634.658Z"
          transform="translate(-79.783 -7.5)"
          fill="var(--primary-base)"
        />
        <path
          d="M197.536,429.457a.457.457,0,0,0-.457-.457h-6.623a.457.457,0,0,0-.457.457v3.426a.457.457,0,0,0,.457.457h6.623a.457.457,0,0,0,.457-.457Zm-.913,2.969h-5.709v-2.512h5.709Z"
          transform="translate(-183.707 -404.935)"
          fill="var(--primary-base)"
        />
      </g>
    </svg>
  );
}
